import React from 'react';
// @ts-ignore
import FullPageComposerView from 'chat/components/FullPageComposer/FullPageComposerView';
// @ts-ignore
import FullPageComposerView2 from 'chat_v2/components/FullPageComposer/FullPageComposerView';
import CurrentUser from 'auth/CurrentUser';

export default function FullPageComposerV2Wrapper(props: any) {
  return CurrentUser.getUser().hasFeature('2021.jul.web.chat-v2') ? <FullPageComposerView2 {...props} /> : <FullPageComposerView {...props} />;
}
